import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ParallaxImage = ({ src, alt, className = "", strength = 12, shade = true, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);

  return (
    <div ref={ref} className={`relative overflow-hidden group ${className}`} data-testid={testId}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, scale: 1.25 }}
        className="img-treat absolute inset-0 h-full w-full object-cover will-change-transform"
        loading="lazy"
      />
      {shade && <div className="absolute inset-0 bg-gradient-to-t from-[#1b2229]/60 via-transparent to-transparent" />}
    </div>
  );
};
